import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { deviationSchema, deviationExtendedSchema } from '../normalizr/schemas/deviation';
import { getDataEntities, getDataEntityById, getDataEntitiesByIds } from '../entities';
import { getUserById } from '../users/selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { getDeviationType, isDeviationAuthor } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import DeviationMediaService from '../../utils/DeviationMediaService';
import { userSchema } from '../normalizr/schemas/user';
export const getNormalizedDeviationById = (state, entityId)=>getDataEntityById(state, deviationSchema, entityId);
const getNormalizedDeviationsByIds = (state, entityIds)=>getDataEntitiesByIds(state, deviationSchema, entityIds);
const getDeviationAuthorsByDeviationIds = (state, entityIds)=>{
    const authorIds = getNormalizedDeviationsByIds(state, entityIds).map((deviation)=>deviation.author).filter((authorId)=>!!authorId);
    return getDataEntitiesByIds(state, userSchema, authorIds);
};
const getDeviationAuthorByDeviationId = (state, entityId)=>{
    const deviation = getNormalizedDeviationById(state, entityId);
    if (!deviation) {
        return;
    }
    return getUserById(state, deviation.author);
};
const getDeviationGroupDestinationsByDeviationIds = (state, entityIds)=>{
    const groupDestinationIds = getNormalizedDeviationsByIds(state, entityIds).map((deviation)=>deviation.groupDestination).filter((groupDestinationId)=>!!groupDestinationId);
    return getDataEntitiesByIds(state, userSchema, groupDestinationIds);
};
const getDeviationGroupDestinationByDeviationId = (state, entityId)=>{
    const deviation = getNormalizedDeviationById(state, entityId);
    if (!deviation) {
        return;
    }
    return getUserById(state, deviation.groupDestination);
};
export const getHasCommentedOnDeviation = (state, deviation)=>{
    if (!deviation.deviationId) {
        return false;
    }
    const normalizedDeviation = getNormalizedDeviationById(state, deviation.deviationId);
    return normalizedDeviation ? normalizedDeviation.hasCommentedOn : deviation.hasCommentedOn;
};
export const createGetDeviationById = ()=>{
    return createSelector([
        getNormalizedDeviationById,
        getDeviationAuthorByDeviationId,
        getDeviationGroupDestinationByDeviationId
    ], (deviation, author, groupDestination)=>{
        if (!deviation) {
            return undefined;
        }
        return _object_spread_props(_object_spread({}, deviation), {
            author,
            groupDestination,
            extended: undefined
        });
    });
};
// a default instance - prefer the selector creator for proper memoization
export const getDeviationById = createGetDeviationById();
export const getExtendedDeviationById = createSelector([
    (state, entityId)=>entityId,
    getDeviationById,
    getDataEntities
], (entityId, deviation, entities)=>{
    if (!deviation || !entities[deviationExtendedSchema.key]) {
        return deviation;
    }
    // extended has a ton of stuff inside, needs to be denormalized
    deviation.extended = denormalize(entityId, deviationExtendedSchema, entities);
    return deviation;
});
export const createGetDeviationsByIds = ()=>{
    return createSelector(getNormalizedDeviationsByIds, getDeviationAuthorsByDeviationIds, getDeviationGroupDestinationsByDeviationIds, (deviations, authors, groupDestinations)=>{
        return deviations.map((deviation)=>_object_spread_props(_object_spread({}, deviation), {
                author: authors.find((author)=>author.userId === deviation.author),
                groupDestination: groupDestinations.find((groupDestination)=>groupDestination.userId === deviation.groupDestination),
                extended: undefined
            }));
    });
};
// a default instance - prefer the selector creator for proper memoization
export const getDeviationsByIds = createGetDeviationsByIds();
export const getIsGif = (deviation)=>DeviationMediaService.isGif(deviation);
export function getIsCurrentUserAuthorOf(state, deviation) {
    const user = getCurrentUser(state);
    return user ? isDeviationAuthor(deviation, user) : false;
}
export function getDeviationEditUrl(_param) {
    var { extended } = _param, deviation = _object_without_properties(_param, [
        "extended"
    ]);
    const deviationType = getDeviationType(deviation);
    // some types never go to edit page
    if ([
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
        DeviationTypes.TIER
    ].includes(deviationType)) {
        return;
    }
    if (deviation.legacyTextEditUrl) {
        return deviation.legacyTextEditUrl;
    }
    // non-legacy journals/lit don't go to edit page
    if (![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE
    ].includes(deviationType)) {
        return extended && extended.editUrl;
    }
}
export function getDeviationIdFromNormalizedId(state, normalizedId) {
    const deviation = getNormalizedDeviationById(state, normalizedId);
    return deviation && deviation.deviationId || normalizedId;
}

//# sourceMappingURL=selectors.js.map